import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-responses-weight-targets',
  templateUrl: './responses-weight-targets.component.html',
  styleUrls: ['./responses-weight-targets.component.scss']
})
export class ResponsesWeightTargetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
